<template>
	<div class="view-content">
		<div class="page-heading">
			<h1>{{ $route.meta.title }}</h1>
		</div>
		<div class="page-content">
			<gutter size="10px" />
			<div class="card padded max-h-screen">
				<p-data-table
					ref="bizunitpeformance"
					:value="performance_results"
					rowGroupMode="subheader"
					groupRowsBy="category"
					scrollable
					scrollHeight="80vh"
					:loading="loading"
				>
					<template #loading>
						<line-loader :show="loading" />
					</template>
					<template #empty>
						<div class="dim">No Data</div>
					</template>
					<template #header>
						<div class="flex justify-between items-center w-full">
							<p-button label="<< More Data" text @click="getNewDates" v-tooltip="loadDatesToolTip" />

							<div class="flex align-items-center justify-content-end w-full activity-quick-filters">
								<quick-filter v-model="timeframe" value="day">Day</quick-filter>
								<quick-filter v-model="timeframe" value="week">Week</quick-filter>
								<quick-filter v-model="timeframe" value="month">Month</quick-filter>
							</div>
						</div>
					</template>
					<p-column frozen class="max-w-12rem">
						<template #body>
							<!-- Profit -->
							<div class="cell bg-gray-800 clickable" @click="toggleHidden('profit')">
								<a
									><icon
										:key="componentKey"
										:type="hide_categories.includes('profit') ? 'plus' : 'minus'"
										class="mr-2" /></a
								><strong class="text-white">Profit</strong>
							</div>
							<div v-if="!hide_categories.includes('profit')" class="clickable" @click="toggleHidden('profit')">
								<div class="cell sub-value text-align-right">OO</div>
								<div class="cell sub-value text-align-right">PN</div>
								<div class="cell sub-value text-align-right font-semibold">Total</div>
							</div>
							<!-- ROI -->
							<div class="cell bg-gray-800 clickable" @click="toggleHidden('roi')">
								<a
									><icon
										:key="componentKey"
										:type="hide_categories.includes('roi') ? 'plus' : 'minus'"
										class="mr-2" /></a
								><strong class="text-white">ROI</strong>
							</div>
							<div v-if="!hide_categories.includes('roi')" class="clickable" @click="toggleHidden('roi')">
								<div class="cell sub-value text-align-right">OO</div>
								<div class="cell sub-value text-align-right">PN</div>
								<div class="cell sub-value text-align-right font-semibold">Total</div>
							</div>
							<!-- Revenue Per Lead -->
							<div class="cell bg-gray-800 clickable" @click="toggleHidden('revenue_per_lead')">
								<a
									><icon
										:key="componentKey"
										:type="hide_categories.includes('revenue_per_lead') ? 'plus' : 'minus'"
										class="mr-2" /></a
								><strong class="text-white">Revenue Per Lead</strong>
							</div>
							<div
								v-if="!hide_categories.includes('revenue_per_lead')"
								@click="toggleHidden('revenue_per_lead')"
								class="clickable"
							>
								<div class="cell sub-value text-align-right">OO</div>
								<div class="cell sub-value text-align-right">PN</div>
								<div class="cell sub-value text-align-right font-semibold">Total</div>
							</div>
							<!-- Cost Per Lead -->
							<div class="cell bg-gray-800 clickable" @click="toggleHidden('cost_per_lead')">
								<a
									><icon
										:key="componentKey"
										:type="hide_categories.includes('cost_per_lead') ? 'plus' : 'minus'"
										class="mr-2" /></a
								><strong class="text-white">Cost Per Lead</strong>
							</div>
							<div
								v-if="!hide_categories.includes('cost_per_lead')"
								class="cost_per_lead clickable"
								@click="toggleHidden('cost_per_lead')"
							>
								<div class="cell sub-value text-align-right">OO</div>
								<div class="cell sub-value text-align-right">PN</div>
								<div class="cell sub-value text-align-right font-semibold">Total</div>
							</div>
							<!-- Customer Count -->
							<div class="cell bg-gray-800 clickable" @click="toggleHidden('customer_count')">
								<a
									><icon
										:key="componentKey"
										:type="hide_categories.includes('customer_count') ? 'plus' : 'minus'"
										class="mr-2" /></a
								><strong class="text-white">Customer Count</strong>
							</div>
							<div
								v-if="!hide_categories.includes('customer_count')"
								@click="toggleHidden('customer_count')"
								class="clickable"
							>
								<div class="cell sub-value text-align-right">OO Tier 1</div>
                <div class="cell sub-value text-align-right">OO Tier 2</div>
								<div class="cell sub-value text-align-right">PN Tier 1</div>
                <div class="cell sub-value text-align-right">PN Tier 2</div>
								<div class="cell sub-value text-align-right font-semibold">Total</div>
							</div>
							<!-- Revenue -->
							<div class="cell bg-gray-800 clickable" @click="toggleHidden('revenue')">
								<a
									><icon
										:key="componentKey"
										:type="hide_categories.includes('revenue') ? 'plus' : 'minus'"
										class="mr-2" /></a
								><strong class="text-white">Revenue</strong>
							</div>
							<div v-if="!hide_categories.includes('revenue')" @click="toggleHidden('revenue')" class="clickable">
								<div class="cell sub-value text-align-right">OO</div>
								<div class="cell sub-value text-align-right">PN</div>
								<div class="cell sub-value text-align-right font-semibold">Total</div>
							</div>
							<!-- Cost -->
							<div class="cell bg-gray-800 clickable" @click="toggleHidden('cost')">
								<a
									><icon
										:key="componentKey"
										:type="hide_categories.includes('cost') ? 'plus' : 'minus'"
										class="mr-2" /></a
								><strong class="text-white">Cost</strong>
							</div>
							<div v-if="!hide_categories.includes('cost')" @click="toggleHidden('cost')" class="clickable">
								<div class="cell sub-value text-align-right">OO</div>
								<div class="cell sub-value text-align-right">PN</div>
								<div class="cell sub-value text-align-right font-semibold">Total</div>
							</div>
							<!-- Counts -->
							<div class="cell bg-gray-800 clickable" @click="toggleHidden('counts')">
								<a
									><icon
										:key="componentKey"
										:type="hide_categories.includes('counts') ? 'plus' : 'minus'"
										class="mr-2" /></a
								><strong class="text-white">Counts</strong>
							</div>
							<div v-if="!hide_categories.includes('counts')" @click="toggleHidden('counts')" class="clickable">
								<div class="cell sub-value text-align-right">OO</div>
								<div class="cell sub-value text-align-right">PN</div>
								<div class="cell sub-value text-align-right font-semibold">Total</div>
							</div>
							<!-- Sanity Check -->
							<div class="cell bg-gray-800 clickable" @click="toggleHidden('sanity_check')">
								<a
									><icon
										:key="componentKey"
										:type="hide_categories.includes('sanity_check') ? 'plus' : 'minus'"
										class="mr-2" /></a
								><strong class="text-white">Sanity Check</strong>
							</div>
							<div
								v-if="!hide_categories.includes('sanity_check')"
								@click="toggleHidden('sanity_check')"
								class="clickable"
							>
								<div class="cell sub-value text-align-right">Campaigns Table Revenue</div>
								<div class="cell sub-value text-align-right">% Difference</div>
							</div>
						</template>
					</p-column>
					<p-column v-for="date in dates" :header="formatDateLabel(date)" :key="date" class="max-w-8rem">
						<template #body="row">
							<!-- profit÷ -->
							<div class="cell" :class="{ 'bg-gray-300': isWeekend(date), 'bg-gray-800': !isWeekend(date) }">
								&nbsp;
							</div>
							<div v-if="!hide_categories.includes('profit')">
								<div class="cell" :class="colorCode(get(row.data, date + '.profit.oo', 0), 'profit', 'oo', date)">
									{{ currency(get(row.data, date + '.profit.oo', 0), 0) }}
								</div>
								<div class="cell" :class="colorCode(get(row.data, date + '.profit.pn', 0), 'profit', 'pn', date)">
									{{ currency(get(row.data, date + '.profit.pn', 0), 0) }}
								</div>
								<div
									class="cell font-semibold"
									:class="colorCode(get(row.data, date + '.profit.total', 0), 'profit', 'total', date)"
								>
									{{ currency(get(row.data, date + '.profit.total', 0), 0) }}
								</div>
							</div>
							<!-- roi -->
							<div class="cell" :class="{ 'bg-gray-300': isWeekend(date), 'bg-gray-800': !isWeekend(date) }">
								&nbsp;
							</div>
							<div v-if="!hide_categories.includes('roi')">
								<div class="cell" :class="colorCode(get(row.data, date + '.roi.oo', 0), 'roi', 'oo', date)">
									{{ percentage(get(row.data, date + '.roi.oo', 0), 0) }}
								</div>
								<div class="cell" :class="colorCode(get(row.data, date + '.roi.pn', 0), 'roi', 'pn', date)">
									{{ percentage(get(row.data, date + '.roi.pn', 0), 0) }}
								</div>
								<div
									class="cell font-semibold"
									:class="colorCode(get(row.data, date + '.roi.total', 0), 'roi', 'total', date)"
								>
									{{ percentage(get(row.data, date + '.roi.total', 0), 0) }}
								</div>
							</div>
							<!-- revenue_per_lead -->
							<div class="cell" :class="{ 'bg-gray-300': isWeekend(date), 'bg-gray-800': !isWeekend(date) }">
								&nbsp;
							</div>
							<div v-if="!hide_categories.includes('revenue_per_lead')">
								<div
									class="cell"
									:class="colorCode(get(row.data, date + '.revenue_per_lead.oo', 0), 'revenue_per_lead', 'oo', date)"
								>
									{{ currency(get(row.data, date + '.revenue_per_lead.oo', 0), 2) }}
								</div>
								<div
									class="cell"
									:class="colorCode(get(row.data, date + '.revenue_per_lead.pn', 0), 'revenue_per_lead', 'pn', date)"
								>
									{{ currency(get(row.data, date + '.revenue_per_lead.pn', 0), 2) }}
								</div>
								<div
									class="cell font-semibold"
									:class="
										colorCode(get(row.data, date + '.revenue_per_lead.total', 0), 'revenue_per_lead', 'total', date)
									"
								>
									{{ currency(get(row.data, date + '.revenue_per_lead.total', 0), 2) }}
								</div>
							</div>
							<!-- cost_per_lead -->
							<div class="cell" :class="{ 'bg-gray-300': isWeekend(date), 'bg-gray-800': !isWeekend(date) }">
								&nbsp;
							</div>
							<div v-if="!hide_categories.includes('cost_per_lead')">
								<div
									class="cell"
									:class="colorCode(get(row.data, date + '.cost_per_lead.oo', 0), 'cost_per_lead', 'oo', date, true)"
								>
									{{ currency(get(row.data, date + '.cost_per_lead.oo', 0), 2) }}
								</div>
								<div
									class="cell"
									:class="colorCode(get(row.data, date + '.cost_per_lead.pn', 0), 'cost_per_lead', 'pn', date, true)"
								>
									{{ currency(get(row.data, date + '.cost_per_lead.pn', 0), 2) }}
								</div>
								<div
									class="cell font-semibold"
									:class="colorCode(get(row.data, date + '.cost_per_lead.total', 0), 'cost_per_lead', 'total', date, true)"
								>
									{{ currency(get(row.data, date + '.cost_per_lead.total', 0), 2) }}
								</div>
							</div>
							<!-- customer_count -->
							<div class="cell" :class="{ 'bg-gray-300': isWeekend(date), 'bg-gray-800': !isWeekend(date) }">
								&nbsp;
							</div>
							<div v-if="!hide_categories.includes('customer_count')">
								<div
									class="cell"
									:class="colorCode(get(row.data, date + '.customer_count.oo_t1', 0), 'customer_count', 'oo_t1', date)"
								>
									{{ numberFormat(get(row.data, date + '.customer_count.oo_t1', 0))}}
								</div>
                <div
                    class="cell"
                    :class="colorCode(get(row.data, date + '.customer_count.oo_t2', 0), 'customer_count', 'oo_t2', date)"
                >
                  {{ numberFormat(get(row.data, date + '.customer_count.oo_t2', 0)) }}
                </div>
								<div
									class="cell"
									:class="colorCode(get(row.data, date + '.customer_count.pn_t1', 0), 'customer_count', 'pn_t1', date)"
								>
									{{ numberFormat(get(row.data, date + '.customer_count.pn_t1', 0)) }}
								</div>
                <div
                    class="cell"
                    :class="colorCode(get(row.data, date + '.customer_count.pn_t2', 0), 'customer_count', 'pn_t2', date)"
                >
                  {{ numberFormat(get(row.data, date + '.customer_count.pn_t2', 0)) }}
                </div>
								<div
									class="cell font-semibold"
									:class="colorCode(get(row.data, date + '.customer_count.total', 0), 'customer_count', 'total', date)"
								>
									{{ numberFormat(get(row.data, date + '.customer_count.total', 0)) }}
								</div>
							</div>
							<!-- revenue -->
							<div class="cell" :class="{ 'bg-gray-300': isWeekend(date), 'bg-gray-800': !isWeekend(date) }">
								&nbsp;
							</div>
							<div v-if="!hide_categories.includes('revenue')">
								<div class="cell" :class="colorCode(get(row.data, date + '.revenue.oo', 0), 'revenue', 'oo', date)">
									{{ currency(get(row.data, date + '.revenue.oo', 0), 0) }}
								</div>
								<div class="cell" :class="colorCode(get(row.data, date + '.revenue.pn', 0), 'revenue', 'pn', date)">
									{{ currency(get(row.data, date + '.revenue.pn', 0), 0) }}
								</div>
								<div
									class="cell font-semibold"
									:class="colorCode(get(row.data, date + '.revenue.total', 0), 'revenue', 'total', date)"
								>
									{{ currency(get(row.data, date + '.revenue.total', 0), 0) }}
								</div>
							</div>
							<!-- cost -->
							<div class="cell" :class="{ 'bg-gray-300': isWeekend(date), 'bg-gray-800': !isWeekend(date) }">
								&nbsp;
							</div>
							<div v-if="!hide_categories.includes('cost')">
								<div class="cell" :class="colorCode(get(row.data, date + '.cost.oo', 0), 'cost', 'oo', date, true)">
									{{ currency(get(row.data, date + '.cost.oo', 0), 0) }}
								</div>
								<div class="cell" :class="colorCode(get(row.data, date + '.cost.pn', 0), 'cost', 'pn', date, true)">
									{{ currency(get(row.data, date + '.cost.pn', 0), 0) }}
								</div>
								<div
									class="cell font-semibold"
									:class="colorCode(get(row.data, date + '.cost.total', 0), 'cost', 'total', date, true)"
								>
									{{ currency(get(row.data, date + '.cost.total', 0), 0) }}
								</div>
							</div>
							<!-- counts -->
							<div class="cell" :class="{ 'bg-gray-300': isWeekend(date), 'bg-gray-800': !isWeekend(date) }">
								&nbsp;
							</div>
							<div v-if="!hide_categories.includes('counts')">
								<div class="cell" :class="colorCode(get(row.data, date + '.counts.oo', 0), 'counts', 'oo', date)">
									{{ numberFormat(get(row.data, date + '.counts.oo', 0)) }}
								</div>
								<div class="cell" :class="colorCode(get(row.data, date + '.counts.pn', 0), 'counts', 'pn', date)">
									{{ numberFormat(get(row.data, date + '.counts.pn', 0)) }}
								</div>
								<div
									class="cell font-semibold"
									:class="colorCode(get(row.data, date + '.counts.total', 0), 'counts', 'total', date)"
								>
									{{ numberFormat(get(row.data, date + '.counts.total', 0)) }}
								</div>
							</div>
							<!-- sanity_check -->
							<div class="cell" :class="{ 'bg-gray-300': isWeekend(date), 'bg-gray-800': !isWeekend(date) }">
								&nbsp;
							</div>
							<div v-if="!hide_categories.includes('sanity_check')">
								<div class="cell" :class="{ 'bg-gray-300': isWeekend(date) }">
									{{ currency(get(row.data, date + '.sanity_check.campaigns_table_revenue', 0), 0) }}
								</div>
								<div class="cell" :class="{ 'bg-gray-300': isWeekend(date) }">
									{{ percentage(get(row.data, date + '.sanity_check.difference', 0), 0) }}
								</div>
							</div>
						</template>
					</p-column>
				</p-data-table>
			</div>
		</div>
	</div>
</template>

<script lang="ts">
import quickFilter from '@/components/widgets/QuickFilter.vue';
import { currency, percentage, colorCell, numberFormat } from '@/lib/Filters';
import { getMAutVerticalPerformanceBizUnits } from '@GQL';
import { get, min, max, map } from 'lodash-es';
import dayjs from 'dayjs';

export default {
	name: 'BizUnitPerformance',
	components: {
		quickFilter,
	},
	inject: ['mq'],
	data() {
		return {
			loading: false,
			timeframe: 'day',
			componentKey: 0,
			hide_categories: [],
			date_range: [],
			group_headers: {
				profit: 'Profit',
				roi: 'ROI',
				revenue_per_lead: 'Revenue Per Lead',
				cost_per_lead: 'Cost Per Lead',
				customer_count: 'Customer Count',
				revenue: 'Revenue',
				cost: 'Cost',
				counts: 'Counts',
				sanity_check: 'Sanity Check',
			},
			minmax: {
				profit: {
					oo: { min: 0, max: 1000 },
					pn: { min: 0, max: 1000 },
					total: { min: 0, max: 1000 },
				},
				roi: {
					oo: { min: 0, max: 1 },
					pn: { min: 0, max: 1 },
					total: { min: 0, max: 1 },
				},
				revenue_per_lead: {
					oo: { min: 0, max: 10 },
					pn: { min: 0, max: 10 },
					total: { min: 0, max: 10 },
				},
				cost_per_lead: {
					oo: { min: 0, max: 10 },
					pn: { min: 0, max: 10 },
					total: { min: 0, max: 10 },
				},
				customer_count: {
					oo_t1: { min: 0, max: 100 },
          oo_t2: { min: 0, max: 100 },
					pn_t1: { min: 0, max: 100 },
          pn_t2: { min: 0, max: 100 },
					total: { min: 0, max: 100 },
				},
				revenue: {
					oo: { min: 0, max: 1000 },
					pn: { min: 0, max: 1000 },
					total: { min: 0, max: 1000 },
				},
				cost: {
					oo: { min: 0, max: 1000 },
					pn: { min: 0, max: 1000 },
					total: { min: 0, max: 1000 },
				},
				counts: {
					oo: { min: 0, max: 100 },
					pn: { min: 0, max: 100 },
					total: { min: 0, max: 100 },
				},
			},
			performance_results: [],
		};
	},
	computed: {
		vertical() {
			return this.$route.meta.vertical;
		},
		loadDatesToolTip() {
			if (this.timeframe === 'day') {
				return 'Load 14 days';
			} else if (this.timeframe === 'week') {
				return 'Load 5 weeks';
			} else {
				return 'Load 3 months';
			}
		},
		dates() {
			return Object.keys(this.performance_results[0]).sort();
		},
	},
	watch: {
		vertical() {
			this.resetReport();
		},
		timeframe(new_value) {
			// based on the gradient we change up the date range
			if (new_value === 'week') {
				// start with 5 weeks back
				// we go to start of week and subtract 5
				const new_start_date = dayjs(this.date_range[1]).subtract(10, 'weeks').startOf('day').format();
				this.date_range[0] = new_start_date;
			} else if (new_value === 'month') {
				const new_start_date = dayjs(this.date_range[1]).startOf('month').subtract(5, 'months').format();
				this.date_range[0] = new_start_date;
			}

			this.getData(this.date_range[0], this.date_range[1], true);
		},
	},
	async mounted() {
		await this.resetReport();
	},
	methods: {
		get,
		currency,
    numberFormat,
		percentage,
		colorCell,
		async resetReport() {
			const start_date = dayjs().subtract(14, 'day').startOf('day').format();
			const end_date = dayjs().subtract(1, 'day').endOf('day').format();
			this.date_range = [start_date, end_date];
			await this.getData(start_date, end_date, true);

			// next tick scroll to the right
			this.scrollToRight();
		},
		scrollToRight() {
			this.$nextTick(() => {
				const tableContainer = this.$refs.bizunitpeformance.$el.querySelector('.p-datatable-wrapper');
				if (tableContainer) {
					tableContainer.scrollLeft = tableContainer.scrollWidth;
				}
			});
		},
		isWeekend(str_date) {
			const day_of_week = dayjs(str_date).day();
			return (day_of_week === 0 || day_of_week === 6) && this.timeframe === 'day';
		},
		formatDateLabel(str_date) {
			// format to mm/dd/yyyy
			return dayjs(str_date).format('MM/DD/YYYY');
		},
		colorCode(value, category, metric, date, inverse = false) {
			// if the date is weekend then we return gray
			if (this.isWeekend(date)) {
				return 'bg-gray-300';
			}
			return colorCell(value, this.minmax[category][metric].min, this.minmax[category][metric].max, inverse);
		},
		toggleHidden(category) {
			if (this.hide_categories.includes(category)) {
				this.hide_categories = this.hide_categories.filter((c) => c !== category);
			} else {
				this.hide_categories.push(category);
			}
			this.componentKey += 1;
		},
		setMinMax(result_obj) {
			const values = Object.values(result_obj);
			// in the result object we must
			this.minmax = {
				profit: {
					oo: { min: min(map(values, 'profit.oo')), max: max(map(values, 'profit.oo')) },
					pn: { min: min(map(values, 'profit.pn')), max: max(map(values, 'profit.pn')) },
					total: { min: min(map(values, 'profit.total')), max: max(map(values, 'profit.total')) },
				},
				roi: {
					oo: { min: min(map(values, 'roi.oo')), max: max(map(values, 'roi.oo')) },
					pn: { min: min(map(values, 'roi.pn')), max: max(map(values, 'roi.pn')) },
					total: { min: min(map(values, 'roi.total')), max: max(map(values, 'roi.total')) },
				},
				revenue_per_lead: {
					oo: { min: min(map(values, 'revenue_per_lead.oo')), max: max(map(values, 'revenue_per_lead.oo')) },
					pn: { min: min(map(values, 'revenue_per_lead.pn')), max: max(map(values, 'revenue_per_lead.pn')) },
					total: { min: min(map(values, 'revenue_per_lead.total')), max: max(map(values, 'revenue_per_lead.total')) },
				},
				cost_per_lead: {
					oo: { min: min(map(values, 'cost_per_lead.oo')), max: max(map(values, 'cost_per_lead.oo')) },
					pn: { min: min(map(values, 'cost_per_lead.pn')), max: max(map(values, 'cost_per_lead.pn')) },
					total: { min: min(map(values, 'cost_per_lead.total')), max: max(map(values, 'cost_per_lead.total')) },
				},
				customer_count: {
          oo_t1: { min: min(map(values, 'customer_count.oo_t1')), max: max(map(values, 'customer_count.oo_t1')) },
					oo_t2: { min: min(map(values, 'customer_count.oo_t2')), max: max(map(values, 'customer_count.oo_t2')) },
					pn_t1: { min: min(map(values, 'customer_count.pn_t1')), max: max(map(values, 'customer_count.pn_t1')) },
          pn_t2: { min: min(map(values, 'customer_count.pn_t2')), max: max(map(values, 'customer_count.pn_t2')) },
					total: { min: min(map(values, 'customer_count.total')), max: max(map(values, 'customer_count.total')) },
				},
				revenue: {
					oo: { min: min(map(values, 'revenue.oo')), max: max(map(values, 'revenue.oo')) },
					pn: { min: min(map(values, 'revenue.pn')), max: max(map(values, 'revenue.pn')) },
					total: { min: min(map(values, 'revenue.total')), max: max(map(values, 'revenue.total')) },
				},
				cost: {
					oo: { min: min(map(values, 'cost.oo')), max: max(map(values, 'cost.oo')) },
					pn: { min: min(map(values, 'cost.pn')), max: max(map(values, 'cost.pn')) },
					total: { min: min(map(values, 'cost.total')), max: max(map(values, 'cost.total')) },
				},
				counts: {
					oo: { min: min(map(values, 'counts.oo')), max: max(map(values, 'counts.oo')) },
					pn: { min: min(map(values, 'counts.pn')), max: max(map(values, 'counts.pn')) },
					total: { min: min(map(values, 'counts.total')), max: max(map(values, 'counts.total')) },
				},
			};
		},
		async getNewDates() {
			// based on interval we subtract
			const start_date = dayjs(this.date_range[0]);
			let new_start_date = start_date.subtract(14, 'days').startOf('day').format();
			if (this.timeframe === 'week') {
				new_start_date = start_date.subtract(5, 'weeks').startOf('day').format();
			} else if (this.timeframe === 'month') {
				new_start_date = start_date.subtract(3, 'months').startOf('day').format();
			}
			this.date_range[0] = new_start_date;
			await this.getData(new_start_date, this.date_range[1]);
		},
		async getData(start_date, end_date, reset_obj = false) {
			this.loading = true;
			try {
				const data = await getMAutVerticalPerformanceBizUnits({
					vertical_id: this.vertical,
					date_interval: this.timeframe,
					date_range: [start_date, end_date],
				});

				let new_base = {
					...get(this.performance_results, '0', {}),
					...get(data, 'rows.0', {}),
				};
				if (reset_obj) {
					new_base = {
						...get(data, 'rows.0', {}),
					};
				}

				this.setMinMax(new_base);

				this.performance_results = [new_base];
			} finally {
				this.loading = false;
			}
		},
	},
};
</script>

<style lang="less" scoped>
:deep(.p-datatable .p-datatable-tbody > tr > td) {
	padding: 0;
}

.clickable {
	&:hover {
		cursor: pointer;
	}
}

.cell {
	padding: 0.25rem 0.5rem;
	&:hover {
		filter: brightness(0.9);
		color: black !important;
	}
}

.sub-value {
	margin: 0;
}
</style>
